import { IScheduleFrequency } from '../../../schedule/types/ISchedule';
import {
  IAnalyticsExtConnectionId,
  IAnalyticsExtConnectionSettings,
  IAnalyticsExtSiteSettings
} from '~src/settings/types/ISiteSettingsForSiteAdmin';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';
import {IAnalyticsExtensionsSettings} from '~src/settings/controllers/SiteSettingsForAnalyticsExtensionsCtrl';

export interface IEditableServerSettings {
  activeDirectorySyncScheduleFrequency?: IScheduleFrequency;
  defaultLanguage?: string;
  defaultLocale?: string;
  defaultStartPage?: string;
  embeddedCredentialsEnabled?: boolean;
  guestEnabled?: boolean;
  recommendationsTrainerScheduleFrequency?: IScheduleFrequency;
  refreshTokenEnabled?: boolean;
  scheduledActiveDirectorySyncEnabled?: boolean;
  schedulingEnabled?: boolean;
  savedAccessTokensEnabled?: boolean;
  savedPasswordsEnabled?: boolean;
  personalSandboxEnabled?: boolean;
  personalSandboxByDefaultEnabled?: boolean;
  signInNoteText?: string;
  signInNoteUrl?: string;
  runNowEnabled?: boolean;
}

export let defaultDashExtServerSettings: IDashExtServerSettings = {
  extensionsGloballyEnabled: true,
  blocklist: []
};

export interface IDashExtServerSettings {
  extensionsGloballyEnabled: boolean;
  blocklist: string[];
}

export let defaultExtsvcServerSettings: IExtsvcServerSettings = {
  enabled: false,
};

export interface IExtsvcServerSettings {
  enabled: boolean;
}

export interface IAnalyticsExtensionsServerSettings {
  analyticsExtensionsSiteSettingsEnabled: IAnalyticsExtSiteSettings;
  analyticsExtensionsServerSettingsEnabled: IExtsvcServerSettings;
}



